//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    props: {
        total_points: [String, Number],
        result: String
    },
    computed: {
        ponits_link () {
            return `/web_page?title=定了！成都市居住证积分从2020年11月6日起开始受理，入户分值线140分!&link=${encodeURIComponent('https://mp.weixin.qq.com/s/7VSf-91uu82fPAGrB_HkYQ')}`
        },
        office_link () {
            return `/web_page?title=成都市居住证积分管理办法&link=${encodeURIComponent('https://mp.weixin.qq.com/s/LN4HR5pJHUyK1pPGyVfMmQ')}`
        },
        is_success () {
            return this.total_points >= 140
        }
    },
    methods: {
        tapJoinGroup () {
            this.$sendCtmEvtLog('积分入户加群点击')
        }
    }
}
